import { MultipleProductCard } from '../MultipleProductCard/MultipleProductCard';
import { SingleProductCard } from '../SingleProductCard/SingleProductCard';
import { SingleUnavailableProductCard } from '../SingleUnavailableProductCard/SingleUnavailableProductCard';
import { PostCardProductButtonProps } from './types';

export const PostCardProductButton = ({ products, businessType }: PostCardProductButtonProps) => {
    if (!products.items.length) {
        return null;
    }

    if (products.items.length > 1) {
        return <MultipleProductCard products={products} businessType={businessType} />;
    }

    const firstProduct = products.items[0];

    if (firstProduct.isUnavailable) {
        return <SingleUnavailableProductCard product={firstProduct} businessType={businessType} />;
    }

    return <SingleProductCard product={firstProduct} businessType={businessType} />;
};
